import $ from "jquery";

const componentTooltipCallOut = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            main: ".js-tooltip-call-out",
            close: ".js-tooltip-call-out__close",
            template: "#js-tooltip-call-out",
            component: ".js-TooltipCallOut",
        };

        if ($(el.main).length === 0) return;

        const template = $(el.template).html();

        $(document).on("click", el.main, function (e) {
            e.preventDefault();

            const data = {
                title: $(this).data("title"),
                description: $(this).data("description"),
                left: `calc(${$(this).offset().left}px - 180px)`,
                top: `calc(${$(this).offset().top}px + 30px)`,
            };
            const regex = /{{(.*?)}}/g;

            const component = template.replace(regex, (match) => {
                return data[match.replace(/{{|}}/g, "")];
            });

            $(el.component).remove();
            $("body").append(component);
        });

        $(document).on("click", el.close, function (e) {
            e.preventDefault();

            $(this).parent().parent().remove();
        });
    };
    init();
};

try {
    componentTooltipCallOut();
} catch (error) {
    console.error("componentTooltipCallOut", error);
}
